import React, { useState } from 'react';
import { Platform, Pressable, TextInput, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';

export default function TasksWorkspaceToolbar({ mode, onModeChange, hasUser, viewMode, onViewModeChange,
  searchQuery, onSearchChange, children }) {
  const { colors, theme } = useTheme();
  const { t } = useTranslation();
  const palette = getCatalogPalette(theme);
  const [showSearch, setShowSearch] = useState(false);
  const modes = [
    ...(hasUser ? [{ id: 'tasks', label: t('pages.tasks.yourTasks') }] : []),
    { id: 'templates', label: t('pages.tasks.templates') },
    ...(hasUser ? [{ id: 'saved', label: t('pages.tasks.saved') }] : []),
  ];
  return <View style={{ gap: 14 }}>
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
      <View style={{ flexDirection: 'row', padding: 4, borderRadius: 12, backgroundColor: palette.preview, gap: 2 }}>
        {modes.map(item => <Pressable key={item.id} accessibilityRole="button" accessibilityLabel={item.label}
          accessibilityState={{ selected: mode === item.id }} {...(Platform.OS === 'web' ? { 'aria-pressed': mode === item.id } : {})}
          onPress={() => onModeChange(item.id)} style={{ paddingHorizontal: 14, minHeight: 36, justifyContent: 'center', borderRadius: 9,
            backgroundColor: mode === item.id ? palette.control : 'transparent' }}>
          <Text size="s" weight={mode === item.id ? 'semibold' : 'medium'} color={mode === item.id ? 'primary' : 'secondary'}>{item.label}</Text>
        </Pressable>)}
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        {children}
        <Pressable accessibilityRole="button" accessibilityLabel={t(showSearch ? 'pages.tasks.closeSearch' : 'pages.tasks.search')}
          onPress={() => { onSearchChange(''); setShowSearch(value => !value); }}
          accessibilityState={{ expanded: showSearch }} {...(Platform.OS === 'web' ? { 'aria-expanded': showSearch } : {})}
          style={{ width: 36, height: 36, alignItems: 'center', justifyContent: 'center', borderRadius: 8 }}>
          <Icon name={showSearch ? 'xmark' : 'magnifying-glass'} size={15} color={colors.text_color_secondary} />
        </Pressable>
        <View style={{ flexDirection: 'row', borderWidth: 1, borderColor: palette.border, borderRadius: 9, padding: 2 }}>
          {['list', 'grid'].map(value => <Pressable key={value} accessibilityRole="button"
            accessibilityLabel={t(value === 'list' ? 'pages.common.list' : 'pages.common.grid')}
            accessibilityState={{ selected: viewMode === value }} {...(Platform.OS === 'web' ? { 'aria-pressed': viewMode === value } : {})}
            onPress={() => onViewModeChange(value)} style={{ width: 32, height: 30, borderRadius: 6, justifyContent: 'center', alignItems: 'center',
              backgroundColor: viewMode === value ? palette.selected : 'transparent' }}>
            <Icon name={value === 'list' ? 'list' : 'grid-2'} size={13} color={colors.text_color_secondary} />
          </Pressable>)}
        </View>
      </View>
    </View>
    {showSearch && <TextInput autoFocus accessibilityLabel={t('pages.tasks.search')} placeholder={t('pages.tasks.search')}
      placeholderTextColor={colors.text_color_secondary} value={searchQuery} onChangeText={onSearchChange}
      style={{ minHeight: 44, borderWidth: 1, borderColor: palette.border, backgroundColor: palette.surface, borderRadius: 12,
        paddingHorizontal: 14, color: colors.text_color_primary, fontSize: 15, ...(Platform.OS === 'web' ? { outlineStyle: 'none' } : {}) }} />}
  </View>;
}
